import React, { useState } from "react";
import { Modal, Backdrop, Fade, CircularProgress } from "@mui/material";
import { Link, useNavigate } from "react-router-dom";
import { ChevronLeft, Close, People } from "@mui/icons-material";
import { API_URL } from "./config";
import Swal from "sweetalert2";

const AdminCellgrp = () => {
  const navigate = useNavigate();
  const [ministryObj, setMinistryObj] = useState(() => {
    const stored = localStorage.getItem("SelectedCellgroup");
    return stored
      ? JSON.parse(stored)
      : {
          id: 0,
          name: "",
          description: "",
          location: "",
          admin: "",
          adminphone: "",
          joined: false,
          leaderStatus: true,
          PendingLeave: false,
          pendingJoin: false,
          Totalembers: 0,
          members: [],
          joinrequesting: 0,
          requestingdata: [],
          leaverequesting: 0,
          leavingdata: [],
        };
  });
  console.log(ministryObj);

  const [memberdata, setMemberdata] = useState({
    id: "",
    name: "",
    surname: "",
    gender: "",
    phone: "",
    email: "",
    requesttime: "",
  });
  const [isactive, setIsactive] = useState(false);
  const [modalVisible, setModalVisible] = useState(false);
  const [currenttab, setCurrenttab] = useState("1");
  const [tableData, setTableData] = useState(ministryObj.requestingdata);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(7);

  const handleCancel = () => {
    setModalVisible(false);
  };

  const setCurrentTab = (num) => {
    setCurrenttab(num);

    if (num === "1") {
      setTableData(ministryObj.requestingdata);
    } else if (num === "2") {
      setTableData(ministryObj.leavingdata);
    } else if (num === "3") {
      setTableData(ministryObj.members);
    }
  };

  const handleAccept = async () => {
    const memberId = memberdata.id;
    const ministryId = ministryObj.id;

    setIsactive(true);

    //Request To Join
    if (currenttab == 1) {
      try {
        let approveResponse = await fetch(
          `${API_URL}/membersmallgrp/approve/${memberId}/${ministryId}`,
          {
            method: "put",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        let approveResJson = await approveResponse.json();
        setIsactive(false);
        Swal.fire({
          text: "Request Approved!",
          icon: "success",
        });
        navigate("/selectcell");
      } catch {
        Swal.fire({
          text: "Error ocurred, check your internet connection!",
          icon: "error",
        });
      }
    }

    //Request To Leave
    if (currenttab == 2) {
      try {
        console.log("2nd");
        let disapResponse = await fetch(
          `${API_URL}/membersmallgrp/leave/${memberId}/${ministryId}`,
          {
            method: "put",
            headers: {
              "Content-Type": "application/json",
            },
          }
        );

        let disapResJson = await disapResponse.json();
        setIsactive(false);
        Swal.fire({
          text: "Request Approved!",
          icon: "success",
        });
        navigate("/selectcell");
      } catch {
        Swal.fire({
          text: "Error ocurred, check your internet connection!",
          icon: "error",
        });
      }
    }
    setModalVisible(false);
  };

  const viewMember = (id) => {
    const result = tableData.find((obj) => obj.MemberID === id);
    console.log("RESULT ", result);
    if (result) {
      setMemberdata({
        id: result.MemberID,
        name: `${result.Name}`,
        surname: `${result.Surname}`,
        gender: result.Gender,
        phone: result.Phone,
        email: result.Email,
        requesttime: result.RequestTime,
      });
      setModalVisible(true);
    }
  };

  return (
    <div
      style={{
        minHeight: "100vh",
        padding: "20px",
      }}
    >
      <div style={styles.container}>
        <div style={styles.viewMiddle}>
          <button
            style={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              border: "0.5px solid #1a6363",
              height: "60px",
              borderRadius: "8px",
              background: "none",
              cursor: "pointer",
            }}
          >
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "100%",
                backgroundColor: "#1a6363",
                border: "0.5px solid #1a6363",
                height: "52px",
                borderRadius: "5px",
                padding: "0 15px",
                alignItems: "center",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#ffffff",
                }}
              >
                {ministryObj.name}
              </span>
              <People
                style={{
                  marginRight: "5px",
                  color: "#ffffff",
                  fontSize: "20px",
                }}
              />
            </div>
          </button>
          <p
            style={{
              fontFamily: "GeneralSansMedium, sans-serif",
              fontSize: "18px",
              color: "#000000",
              marginTop: "30px",
              marginBottom: "30px",
              alignSelf: "center",
              textAlign: "justify",
            }}
          >
            {ministryObj.description}
          </p>

          <div
            style={{
              display: "flex",
              flexDirection: "row",
              width: "100%",
              justifyContent: "space-between",
              marginBottom: "20px",
            }}
          >
            <button
              onClick={() => setCurrentTab("1")}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "32%",
                backgroundColor: currenttab === "1" ? "#1a6363" : "#ffffff",
                border: "0.5px solid #1a6363",
                height: "52px",
                borderRadius: "8px",
                padding: "0 15px",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: currenttab === "1" ? "#ffffff" : "#000000",
                }}
              >
                New
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: currenttab === "1" ? "#ffffff" : "#000000",
                }}
              >
                {ministryObj.joinrequesting}
              </span>
            </button>
            <button
              onClick={() => setCurrentTab("2")}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "32%",
                backgroundColor: currenttab === "2" ? "#1a6363" : "#ffffff",
                border: "0.5px solid #1a6363",
                height: "52px",
                borderRadius: "8px",
                padding: "0 15px",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: currenttab === "2" ? "#ffffff" : "#000000",
                }}
              >
                Leaving
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: currenttab === "2" ? "#ffffff" : "#000000",
                }}
              >
                {ministryObj.leaverequesting}
              </span>
            </button>
            <button
              onClick={() => setCurrentTab("3")}
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                width: "32%",
                backgroundColor: currenttab === "3" ? "#1a6363" : "#ffffff",
                border: "0.5px solid #1a6363",
                height: "52px",
                borderRadius: "8px",
                padding: "0 15px",
                alignItems: "center",
                cursor: "pointer",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: currenttab === "3" ? "#ffffff" : "#000000",
                }}
              >
                All
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: currenttab === "3" ? "#ffffff" : "#000000",
                }}
              >
                {ministryObj.members.length}
              </span>
            </button>
          </div>

          <div style={{ width: "100%", overflowX: "auto" }}>
            <table style={{ width: "100%", borderCollapse: "collapse" }}>
              <thead>
                <tr style={{ backgroundColor: "#f5f5f5" }}>
                  <th style={styles.tableHeader}>Full Name</th>
                  <th style={styles.tableHeader}>Phone</th>
                  <th style={styles.tableHeader}>Actions</th>
                </tr>
              </thead>
              <tbody>
                {tableData
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((member) => (
                    <tr
                      key={member.id}
                      style={{ borderBottom: "1px solid #ddd" }}
                    >
                      <td style={styles.tableCell}>
                        {member.Name} {member.Surname}
                      </td>
                      <td style={styles.tableCell}>{member.Phone}</td>
                      <td style={styles.tableCell}>
                        <button
                          onClick={() => viewMember(member.MemberID)}
                          style={{
                            backgroundColor: "#1a6363",
                            color: "white",
                            border: "none",
                            padding: "5px 10px",
                            borderRadius: "4px",
                            cursor: "pointer",
                          }}
                        >
                          View
                        </button>
                      </td>
                    </tr>
                  ))}
              </tbody>
            </table>
            <div
              style={{
                display: "flex",
                justifyContent: "space-between",
                marginTop: "10px",
              }}
            >
              <div>
                <span>Rows per page: </span>
                <select
                  value={rowsPerPage}
                  onChange={(e) => setRowsPerPage(Number(e.target.value))}
                  style={{ marginRight: "10px" }}
                >
                  {[7, 14, 21].map((option) => (
                    <option key={option} value={option}>
                      {option}
                    </option>
                  ))}
                </select>
              </div>
              <div>
                <span>
                  {page * rowsPerPage + 1}-
                  {Math.min((page + 1) * rowsPerPage, tableData.length)} of{" "}
                  {tableData.length}
                </span>
                <button
                  onClick={() => setPage((p) => Math.max(0, p - 1))}
                  disabled={page === 0}
                  style={{ margin: "0 10px" }}
                >
                  Previous
                </button>
                <button
                  onClick={() => setPage((p) => p + 1)}
                  disabled={(page + 1) * rowsPerPage >= tableData.length}
                >
                  Next
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        open={modalVisible}
        onClose={handleCancel}
        closeAfterTransition
        BackdropComponent={Backdrop}
        BackdropProps={{
          timeout: 500,
        }}
      >
        <Fade in={modalVisible}>
          <div style={styles.modalView}>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#000000",
                  alignSelf: "center",
                }}
              >
                {currenttab === "1" && "Request To Join"}
                {currenttab === "2" && "Request To Leave"}
                {currenttab === "3" && "Member Data"}
              </span>
              <Close
                style={{
                  color: "#000000",
                  fontSize: "25px",
                  cursor: "pointer",
                }}
                onClick={() => handleCancel()}
              />
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "50px",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#000000",
                  alignSelf: "center",
                }}
              >
                Name
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#1a6363",
                  alignSelf: "center",
                }}
              >
                {memberdata.name}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "30px",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#000000",
                  alignSelf: "center",
                }}
              >
                Surname
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#1a6363",
                  alignSelf: "center",
                }}
              >
                {memberdata.surname}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "30px",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#000000",
                  alignSelf: "center",
                }}
              >
                Mobile Number
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#1a6363",
                  alignSelf: "center",
                }}
              >
                {memberdata.phone}
              </span>
            </div>
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "space-between",
                marginTop: "30px",
              }}
            >
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#000000",
                  alignSelf: "center",
                }}
              >
                Email
              </span>
              <span
                style={{
                  fontFamily: "GeneralSansMedium, sans-serif",
                  fontSize: "18px",
                  color: "#1a6363",
                  alignSelf: "center",
                }}
              >
                {memberdata.email}
              </span>
            </div>

            <div style={styles.viewBtns}>
              {currenttab !== "3" && (
                <button
                  onClick={() => {
                    setModalVisible(false);
                    handleAccept();
                  }}
                  style={styles.btnBtns1}
                  disabled={isactive}
                >
                  {isactive ? (
                    <CircularProgress size={24} style={{ color: "#ffffff" }} />
                  ) : (
                    <span style={styles.txtBtnTxt1}>Accept</span>
                  )}
                </button>
              )}
            </div>
          </div>
        </Fade>
      </Modal>
    </div>
  );
};

const styles = {
  container: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    padding: "0 20px",
    maxWidth: "1200px",
    margin: "0 auto",
  },
  viewTop: {
    flex: "0.8",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    width: "100%",
    marginTop: "20px",
  },
  imgLogo: {
    width: "100%",
    height: "35px",
    borderRadius: "22.5px",
    alignSelf: "center",
    objectFit: "cover",
  },
  viewMiddle: {
    flex: "8",
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginTop: "10px",
  },
  modalView: {
    margin: "20px auto",
    height: "500px",
    padding: "30px 15px",
    backgroundColor: "#ffffff",
    borderRadius: "20px",
    boxShadow: "0 0 10px rgba(0,0,0,0.25)",
    width: "90%",
    maxWidth: "500px",
    position: "relative",
    outline: "none",
  },
  viewBtns: {
    display: "flex",
    flexDirection: "row",
    width: "100%",
    marginTop: "70px",
    justifyContent: "flex-end",
  },
  btnBtns1: {
    width: "49%",
    height: "55px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    borderRadius: "7px",
    backgroundColor: "#000000",
    border: "none",
    cursor: "pointer",
  },
  txtBtnTxt1: {
    fontSize: "14px",
    fontFamily: "GeneralSansMedium, sans-serif",
    textAlign: "center",
    color: "#ffffff",
  },
  tableHeader: {
    padding: "12px 15px",
    textAlign: "left",
    backgroundColor: "#f5f5f5",
    fontFamily: "GeneralSansMedium, sans-serif",
  },
  tableCell: {
    padding: "12px 15px",
    textAlign: "left",
    borderBottom: "1px solid #ddd",
  },
};

export default AdminCellgrp;
